 $(document).ready(function(){
   var usingInches = false;
          document.querySelector('input#change_length_unit').addEventListener('click', (e) => {
            usingInches = e.target.checked;
            if(usingInches) {
              $('#width-unit-label').text('Inches');
              $('#length-unit-label').text('Inches');
            } else {
              $('#width-unit-label').text('Feet');
              $('#length-unit-label').text('Feet');
            }
          })
  calculateVol()
  $('.calc-body input').keyup(calculateVol)
  $('.calc-to-cart').click(function(){
    preExsitingVal = $('#quantity_').val();
    if($(this).hasClass('plus-fifteen')) {
		$('.quantity-selector__input').val($('.final-plus-fifteen').text());
    } else {
  		$('.quantity-selector__input').val($('.final-ammount').text());
    }
    $('button.button.button--xl.button--secondary[type="submit"]').click();
    $('#quantity_').val(preExsitingVal)
  });
   
  function calculateVol() {
    
    if($('#calc-width-input').val().length > 0 && $('#calc-length-input').val().length > 0) {
      $('.calc-out').removeClass('grayed')
      width = $('#calc-width-input').val();
      length = $('#calc-length-input').val();
      if(usingInches) {
        width = width / 12;
        length = length / 12;
      }
      factor = $('#area-factor').val();
      $('.final-ammount').text(Math.ceil((width * length) / factor));
      $('.final-plus-fifteen').text(Math.ceil((width * length * 1.15 ) / factor));
      $('.calc-out').slideDown()
    } else {
      if(!$('.calc-out').hasClass('grayed')) $('.calc-out').addClass('grayed')
    }
  }
   
  $(".calc-width,calc-length").keydown(function (e) {
        // Allow: backspace, delete, tab and escape.
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
            (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
            (e.keyCode >= 35 && e.keyCode <= 39)) { return; }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });
  })